/* istanbul ignore file */
/* istanbul ignore file */
import { EnumField, FieldProps, useFieldHelper } from 'framework/ui/field';
import React from 'react';
import { getSourceOptions } from 'domain/recruiting/candidate/applications/shared/candidateApplicationService';

const CandidateApplicationSourceField = (props: FieldProps) => {
  const { getValue, getLabel } = useFieldHelper(props);

  return <EnumField label={getLabel() || 'Source'} value={getValue()} options={getSourceOptions()} />;
};

export default CandidateApplicationSourceField;
